/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ({

/***/ 23:
/***/ (function(module, exports) {

/* global appData */
// appData declared in the view
var coolBigIcon = document.querySelector('#coolBigIcon');

function handleSignInFrameMessage(messageEvent) {
  if (messageEvent.origin !== window.location.origin) {
    return;
  }

  var signInFrameEvent = messageEvent.data;

  switch (signInFrameEvent.event) {
    case 'FRAME_RESIZE':
      {
        document.querySelector('#signInFrame').style.height = "".concat(signInFrameEvent.detail.height + 5, "px");
        break;
      }

    case 'SIGNIN_START':
      {
        swapIcon('signInTitle', 'lock');
        document.querySelector('#notMember').classList.remove('noDisplay');
        document.querySelector('#helpText').classList.add('noDisplay');
        break;
      }

    case 'SIGNIN_COMPLETE':
      {
        var attribute = 'data-return-url';

        if (signInFrameEvent.detail.passwordReset) {
          attribute = 'data-credentials-url';
        }

        setTitle('signInSuccess');

        if (signInFrameEvent.detail.type === 'mfa') {
          changeColor('green', 'shield');
          nodIcon();
          redirect(attribute);
          break;
        }

        if (coolBigIcon.classList.contains('multiUser')) {
          changeColor('green', 'multiUser');
          nodIcon();
          redirect(attribute);
          break;
        }

        changeColor('green', 'unlocked', 'lock');
        redirect(attribute);
        break;
      }

    case 'SIGNIN_INVALID_CREDENTIALS':
    case 'SIGNIN_MALFORMED':
      {
        changeColor('red', 'lock');
        setTitle('signInFailed');
        shakeIcon();
        break;
      }

    case 'SIGNIN_SERVER_ERROR':
      {
        changeColor('red', 'lock');
        setTitle('serverError');
        shakeIcon();
        break;
      }

    case 'SIGNIN_NETWORK_ERROR':
      {
        changeColor('red', 'lock');
        setTitle('networkError');
        shakeIcon();
        break;
      }

    case 'SIGNIN_ACCOUNT_LOCKED':
      {
        if (coolBigIcon.classList.contains('clock')) {
          setClockTime();
          changeColor('red', 'clock');
          shakeIcon();
          break;
        } // this timeout refreshes the page after the 30 minutes


        setTimeout(function () {
          location.reload();
        }, 1800000);
        setClockTime();
        swapIcon('accountLocked', 'red', 'clock');
        break;
      }

    case 'SIGNIN_MULTI_ACCOUNT':
      {
        swapIcon('selectAccount', 'multiUser');
        document.querySelector('#notMember').classList.add('noDisplay');
        break;
      }

    case 'SIGNIN_FACEBOOK_ERROR':
      {
        removeAll();
        document.querySelector('#coolBigIcon').classList.add('red');
        document.querySelector('#coolBigIcon').classList.add('lock');
        setTitle('facebookFailed');
        break;
      }

    case 'PASSWORD_RESET_START':
      {
        swapIcon('resetPassword', 'key');
        document.querySelector('#notMember').classList.add('noDisplay');
        document.querySelector('#helpText').classList.remove('noDisplay');
        document.querySelector('#helpText a').setAttribute('data-track-click', 'reset password : request : get help');
        setTitle('resetPassword');
        break;
      }

    case 'PASSWORD_RESET_EMAIL_MALFORMED':
      {
        setTitle('emailFailed');
        changeColor('red', 'key');
        shakeIcon();
        break;
      }

    case 'PASSWORD_RESET_EMAIL_SENT':
      {
        document.querySelector('#helpText a').setAttribute('data-track-click', 'reset password : code verify : get help');
        setTitle('resetPasswordCode', "<strong>".concat(signInFrameEvent.detail.email, "</strong>"));
        changeColor('blue', 'key');
        break;
      }

    case 'PASSWORD_RESET_CODE_VALID':
      {
        document.querySelector('#helpText a').setAttribute('data-track-click', 'reset password : new password : get help');
        setTitle('resetPasswordNew');
        changeColor('blue', 'key');
        break;
      }

    case 'PASSWORD_RESET_CODE_EXPIRED':
      {
        setTitle('codeExpired');
        changeColor('red', 'clock');
        shakeIcon();
        break;
      }

    case 'PASSWORD_RESET_CODE_INVALID':
    case 'PASSWORD_RESET_CODE_MALFORMED':
      {
        setTitle('codeFailed');
        changeColor('red', 'key');
        shakeIcon();
        break;
      }

    case 'PASSWORD_RESET_SERVER_ERROR':
      {
        changeColor('red', 'key');
        shakeIcon();
        setTitle('serverError');
        break;
      }

    case 'PASSWORD_RESET_NETWORK_ERROR':
      {
        changeColor('red', 'key');
        shakeIcon();
        setTitle('networkError');
        break;
      }

    case 'PASSWORD_RESET_PASSWORD_SAVED':
      {
        document.querySelector('#helpText a').setAttribute('data-track-click', 'reset password : complete : get help');
        setTitle('resetSuccess');
        changeColor('green', 'key');
        break;
      }

    case 'PASSWORD_RESET_PASSWORD_MALFORMED':
      {
        setTitle('resetFail');
        changeColor('red', 'key');
        shakeIcon();
        break;
      }

    case 'PASSWORD_RESET_PASSWORD_MISMATCH':
      {
        setTitle('resetFail');
        changeColor('red', 'key');
        shakeIcon();
        break;
      }

    case 'MFA_START':
      {
        document.querySelector('#notMember').classList.add('noDisplay');
        swapIcon('mfa', 'shield');
        break;
      }

    case 'MFA_CODE_MALFORMED':
    case 'MFA_CODE_INVALID':
      {
        setTitle('mfaFailed');
        changeColor('red', 'shield');
        shakeIcon();
        break;
      }

    case 'MFA_CODE_EXPIRED':
      {
        setTitle('mfaExpired');
        changeColor('red', 'clock');
        shakeIcon();
        break;
      }

    case 'MFA_SERVER_ERROR':
      {
        changeColor('red', 'lock');
        shakeIcon();
        setTitle('serverError');
        break;
      }

    case 'MFA_NETWORK_ERROR':
      {
        changeColor('red', 'lock');
        shakeIcon();
        setTitle('networkError');
        break;
      }

    case 'RECOVERY_CODE_START':
      {
        swapIcon('recoveryCode', 'lock');
        break;
      }

    case 'RECOVERY_CODE_MALFORMED':
    case 'RECOVERY_CODE_INVALID':
      {
        setTitle('recoveryCodeFailed');
        changeColor('red', 'lock');
        shakeIcon();
        break;
      }

    case 'RECOVERY_CODE_SERVER_ERROR':
      {
        changeColor('red', 'lock');
        shakeIcon();
        setTitle('serverError');
        break;
      }

    case 'RECOVERY_CODE_NETWORK_ERROR':
      {
        changeColor('red', 'lock');
        shakeIcon();
        setTitle('networkError');
        break;
      }

    case 'RECOVERY_CODE_EXPIRED_CREDENTIALS':
      {
        setTitle('recoveryCodeExpiredCred');
        changeColor('red', 'clock');
        shakeIcon();
        break;
      }

    default:
      {
        break;
      }
  }
}

function removeAll() {
  coolBigIcon.classList.remove('lock');
  coolBigIcon.classList.remove('key');
  coolBigIcon.classList.remove('multiUser');
  coolBigIcon.classList.remove('clock');
  coolBigIcon.classList.remove('shield');
  coolBigIcon.classList.remove('red');
  coolBigIcon.classList.remove('orange');
  coolBigIcon.classList.remove('green');
  coolBigIcon.classList.remove('blue');
}

function setTitle(titleId) {
  var postScript = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  document.querySelector('#signInTitle').innerHTML = appData.titleStrings[titleId];
  document.querySelector('#signInSubTitle').innerHTML = "".concat(appData.subTitleStrings[titleId], " ").concat(postScript);
}

function shakeIcon() {
  coolBigIcon.classList.add('shake');
  setTimeout(function () {
    coolBigIcon.classList.remove('shake');
  }, 1000);
}

function nodIcon() {
  coolBigIcon.classList.add('nod');
  setTimeout(function () {
    coolBigIcon.classList.remove('nod');
  }, 1000);
}

function zoomIn() {
  coolBigIcon.classList.add('zoomIn');
  setTimeout(function () {
    coolBigIcon.classList.remove('zoomIn');
    coolBigIcon.classList.remove('zoomedOut');
  }, 500);
}

function zoomOut() {
  coolBigIcon.classList.add('zoomOut');
  setTimeout(function () {
    coolBigIcon.classList.add('zoomedOut');
    coolBigIcon.classList.remove('zoomOut');
  }, 200);
}

function swapIcon(title) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (coolBigIcon.classList.contains('zoomedOut')) {
    removeAll();
    args.forEach(function (item) {
      coolBigIcon.classList.add(item);
    });
    zoomIn();
    setTitle(title);
  } else {
    zoomOut();
    setTimeout(function () {
      setTitle(title);
      removeAll();
      args.forEach(function (item) {
        coolBigIcon.classList.add(item);
      });
      zoomIn();
    }, 200);
  }
}

function changeColor(color) {
  for (var _len2 = arguments.length, icons = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    icons[_key2 - 1] = arguments[_key2];
  }

  coolBigIcon.classList.add('changeColor');
  icons.forEach(function (item) {
    coolBigIcon.classList.add(item);
  });

  if (document.querySelector('#iconBackgroundTransition').classList) {
    document.querySelector('#iconBackgroundTransition').classList.add(color);
  }

  setTimeout(function () {
    removeAll();
    coolBigIcon.classList.add(color);
    icons.forEach(function (item) {
      coolBigIcon.classList.add(item);
    });
    coolBigIcon.classList.remove('changeColor');

    if (document.querySelector('#iconBackgroundTransition').classList) {
      document.querySelector('#iconBackgroundTransition').classList.remove(color);
    }
  }, 200);
}

function setClockTime() {
  var currentTime = new Date();
  var minutes = currentTime.getMinutes();
  var minuteAngle = minutes / 60 * 360 - 45;
  var hours = currentTime.getHours();
  var hourAngle = (hours * 60 + minutes) / 720 * 360 + 60;
  document.querySelector('#minuteHand').style.transform = "rotate(".concat(minuteAngle + 180, "deg)");
  document.querySelector('#hourHand').style.transform = "rotate(".concat(hourAngle, "deg)");
  coolBigIcon.classList.add('animateTime');
  setTimeout(function () {
    coolBigIcon.classList.remove('animateTime');
  }, 15000);
}

setInterval(function () {
  if (coolBigIcon.classList.contains('lock') && !coolBigIcon.classList.contains('red') && !coolBigIcon.classList.contains('green')) {
    coolBigIcon.classList.add('tap');
    setTimeout(function () {
      coolBigIcon.classList.remove('tap');
    }, 1000);
  }
}, 45000);

function redirect(attribute) {
  window.setTimeout(function () {
    window.location = document.getElementById('signInPage').getAttribute(attribute);
  }, 300);
}

window.addEventListener('message', handleSignInFrameMessage, false);

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/signin/index.js